{
  "logout": "Cerrar sesión",
  "accessGranted": "Acceso concedido",
  "addNewEntity": "Añadir nuevo perfil",
  "viewAllProfiles": "Ver todos los perfiles",
  "language": "Idioma",
  "resourcesArticles": "Recursos y artículos",
  "contactSupport": "Contactar con el servicio de asistencia",
  "updateAvatar": "Actualizar avatar",
  "notifications": "Configuración de notificaciones",
  "loginSettings": "Gestionar inicio de sesión"
}
